import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sw-sol-wallets',
  template: `
    <p>
      sol-wallets works!
    </p>
  `,
  styles: [
  ]
})
export class SolWalletsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
